/* eslint-disable react/prop-types */
import React from "react";
import MusicIcon from "lazy_components/icons/icn_category_music";
import PerformanceIcon from "lazy_components/icons/icn_category_perf";
import VisualIcon from "lazy_components/icons/icn_category_visual";
import Label from "components/ui/Input/Label";
import RadioSelect from "components/ui/RadioSelect";
import OptionsBox from "components/ui/OptionsBox";
import withAlertModalContext from "./context";
import { dataLayer } from "../../../../lib/analytics";

const OPTIONS = [
  {
    name: I18n.t("categories.music"),
    value: "music",
    icon: MusicIcon,
  },
  {
    name: I18n.t("categories.performances"),
    value: "performances",
    icon: PerformanceIcon,
  },
  {
    name: I18n.t("categories.graffiti"),
    value: "graffiti",
    icon: VisualIcon,
  },
];

const Category = ({ context }) => {
  const {
    updateData,
    data: { category: selectedCategory, service_types: selectedServiceTypes },
    errors,
    clearError,
    serviceTypes,
  } = context;

  return (
    <div className="b-inquiry-modal__step">
      <Label>{I18n.t("alert_modal.category.subtitle")}</Label>
      <RadioSelect
        options={OPTIONS}
        gridLayout
        selectedValue={selectedCategory}
        onChange={(category) => {
          if (selectedCategory !== category) {
            updateData({ service_types: [] });
          }
          clearError("category");
          clearError("service_types");
          updateData({ category });
        }}
      />
      {errors.category && (
        <small className="text-danger">{errors.category}</small>
      )}
      {selectedCategory && (
        <div style={{ marginTop: 10 }}>
          <OptionsBox
            title={I18n.t("smart_form.service_details.please_select")}
            style={{ flex: 1 }}
          >
            {selectedCategory && (
              <div>
                <label htmlFor="all_sub_types" key={I18n.t("subtypes.all")}>
                  <input
                    type="checkbox"
                    id="all_sub_types"
                    value="all"
                    aria-label="all"
                    checked={
                      serviceTypes[selectedCategory].length
                      === selectedServiceTypes.length
                    }
                    onChange={(e) => {
                      const isChecked = e.target.checked;
                      if (isChecked) {
                        updateData({
                          service_types: serviceTypes[selectedCategory],
                        });
                      } else {
                        updateData({ service_types: [] });
                      }
                      clearError("service_types");
                    }}
                  />
                  {I18n.t("subtypes.all")}
                </label>
                {serviceTypes[selectedCategory].map((subType) => {
                  return (
                    <label
                      htmlFor={`sub_type_${subType}`}
                      key={`sub_type_${subType}_label`}
                    >
                      <input
                        key={`sub_type_${subType}`}
                        type="checkbox"
                        id={`sub_type_${subType}`}
                        value={subType}
                        aria-label={subType}
                        checked={selectedServiceTypes.includes(subType)}
                        onChange={(e) => {
                          const isChecked = e.target.checked;
                          const { value } = e.target;
                          if (isChecked) {
                            updateData({
                              service_types: [...selectedServiceTypes, value],
                            });
                          } else {
                            updateData({
                              service_types: selectedServiceTypes.filter(
                                (st) => st !== value,
                              ),
                            });
                          }
                          clearError("service_types");
                        }}
                      />
                      {I18n.t(`subtypes.${subType}`)}
                    </label>
                  );
                })}
              </div>
            )}
          </OptionsBox>
          {errors.service_types && (
            <small className="text-danger">{errors.service_types}</small>
          )}
        </div>
      )}
    </div>
  );
};

export const validation = (data) => {
  const errors = {};
  if (!data.category) {
    errors.category = I18n.t("smart_form.errors.please_choose_one");
  } else if (!data.service_types.length) {
    errors.service_types = I18n.t("smart_form.errors.please_choose_one");
  }
  if (Object.keys(errors).length > 0) {
    dataLayer.push({
      event: "jobBoardAlertSettingsNextError",
      step: "category",
    });
  }
  return errors;
};

export default withAlertModalContext(Category);
